import client from "../apolloClient";
import { gql } from "@apollo/client";

// GraphQL Queries
const GET_CITY_OPTIONS = gql`
  query {
    cityOptions {
      value
      label
    }
  }
`;

const GET_SCREEN_TAG_OPTIONS = gql`
  query {
    screenTagOptions {
      value
      label
    }
  }
`;

const GET_REGION_OPTIONS = gql`
  query ($cityId: ID) {
    regionOptions(cityId: $cityId) {
      value
      label
    }
  }
`;

const GET_RESTAURANT_OPTIONS = gql`
  query {
    restaurantOptions {
      value
      label
    }
  }
`;

const GET_AD_GROUP_OPTIONS = gql`
  query {
    adGroupOptions {
      value
      label
    }
  }
`;

const GET_PLAYLIST_TAG_OPTIONS = gql`
  query {
    playlistTagOptions {
      value
      label
    }
  }
`;

const GET_CLIENT_OPTIONS = gql`
  query {
    clientOptions {
      value
      label
    }
  }
`;

const GET_ROLE_OPTIONS = gql`
  query {
    roleOptions {
      value
      label
    }
  }
`;

const GET_TEMPLATE_CATEGORY_OPTIONS = gql`
  query {
    templateCategoryOptions {
      value
      label
    }
  }
`;

const GET_SCREEN_OPTIONS = gql`
  query {
    screenOptions {
      value
      label
    }
  }
`;

const GET_PLAYLIST_OPTIONS = gql`
  query {
    playlistOptions {
      value
      label
    }
  }
`;

const GET_CREATIVE_REPORT_OPTIONS = gql`
  query ($adGroupId: ID!) {
    creativeReportOptions(adGroupId: $adGroupId) {
      value
      label
    }
  }
`;

export const dropdownService = {
  getCityOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_CITY_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.cityOptions;
  },

  getScreenTagOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_SCREEN_TAG_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.screenTagOptions;
  },

  getRegionOptions: async (cityId?: string): Promise<any> => {
    const response = await client.query({
      query: GET_REGION_OPTIONS,
      variables: { cityId },
      fetchPolicy: "no-cache",
    });
    return response.data.regionOptions;
  },

  getRestaurantOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_RESTAURANT_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.restaurantOptions;
  },

  getAdGroupOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_AD_GROUP_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.adGroupOptions;
  },

  getPlaylistTagOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_PLAYLIST_TAG_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.playlistTagOptions;
  },

  getClientOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_CLIENT_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.clientOptions;
  },

  getRoleOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_ROLE_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.roleOptions;
  },

  getTemplateCategoryOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_TEMPLATE_CATEGORY_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.templateCategoryOptions;
  },

  getScreenOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_SCREEN_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.screenOptions;
  },

  getPlaylistOptions: async (): Promise<any> => {
    const response = await client.query({
      query: GET_PLAYLIST_OPTIONS,
      fetchPolicy: "no-cache",
    });
    return response.data.playlistOptions;
  },

  getCreativeReportOptions: async (adGroupId: string): Promise<any> => {
    const response = await client.query({
      query: GET_CREATIVE_REPORT_OPTIONS,
      variables: { adGroupId },
      fetchPolicy: "no-cache",
    });
    return response.data.creativeReportOptions;
  },
};
